import { ValidationType } from 'types/GlobalTypes';

export const ShouldNotBeEmpty: ValidationType = (value: string) => value?.length === 0 && 'IS_EMPTY';

export const haveSpaces: ValidationType = (value: string) => value.split('').includes(' ') && 'HAVE_SPACES';

export const objectHaveEmptyKey: ValidationType = (key: string, object: any) =>
  Object.entries(object).some(([k, v]) => !!(k === key && !v)) && `OBJECT_HAVE_EMPTY_KEY`;

export const arrayHasObjectWithEmptyKey: ValidationType = (key: string, array: any[]) =>
  !!array.some((item) => objectHaveEmptyKey(key, item)) && `ARRAY_HAVE_OBJECT_WITH_EMPTY_KEY`;

// the first param is an array of invalid data
export const includesInvalidValue =
  (array: string[] = []): ValidationType =>
  (value: string) =>
    array.includes(value) && `INCLUDES_INVALID_VALUE`;

// this validation can be used to insure that a value/key is only used once in an array of inputs
export const ensureThatValueExistOnlyOnce =
  (array: string[] = []): ValidationType =>
  (value: string) =>
    array.filter((item) => item.trim() === value.trim()).length > 1 && `VALUE_HAS_ALREADY_BEEN_USED_BEFORE`;

export const arrayHasObjectWithAlreadyUsedKey: ValidationType = (key: string, array: any[]) => {
  const arrValues = array.map((item) => item[key].trim());
  return arrValues.length !== new Set(arrValues).size && `DUPLICATE_KEY`;
};

export const EmailShouldBeValid: ValidationType = (value: string) => {
  const emailRegex = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return !emailRegex.test(value) && 'EMAIL_NOT_VALID';
};

export const ShouldBeNumber: ValidationType = (value: string) => {
  const numberRegex = new RegExp(/^[0-9]*$/);
  return !numberRegex.test(value) && 'NOT_A_NUMBER';
};

export const DevopsLinkShouldBeValid: ValidationType = (value: string) => {
  const azureDevopsUrlPrefix = "^https://dev.azure\\.com/trackman/";

  const regex = new RegExp(`${azureDevopsUrlPrefix}`);

  try {
    const decodedUrl = decodeURIComponent(value.trim());
    return !regex.test(decodedUrl) && 'LINK_NOT_VALID';
  } catch (e) {
    // If decoding fails, it's likely not a valid URL
    return 'LINK_NOT_VALID';
  }
};